import type { FC, MutableRefObject } from "react";
import { SWReactTableWrapperContextConsumer } from "app/components/React/Table/SWReactTableWrapperSelectionContext";
import type {
    IDomainSelection } from "app/pages/industry-analysis/market-builder/tabs/common/domain-selection/DomainSelection";
import {
    DomainSelection,
} from "app/pages/industry-analysis/market-builder/tabs/common/domain-selection/DomainSelection";

type IDomainSelectionWrapper = {
    clearAllSelectedRowsRef: MutableRefObject<VoidFunction>;
} & Pick<IDomainSelection, "addDomains" | "isDisabled">;

export const DomainSelectionWrapper: FC<IDomainSelectionWrapper> = (props) => {
    const { clearAllSelectedRowsRef } = props;
    return (
        <SWReactTableWrapperContextConsumer>
            {({ selectedRows, clearAllSelectedRows }) => {
                clearAllSelectedRowsRef.current = clearAllSelectedRows;
                return (
                    <DomainSelection
                        {...props}
                        selectedRows={selectedRows}
                        clearAllSelectedRows={clearAllSelectedRows}
                    />
                );
            }}
        </SWReactTableWrapperContextConsumer>
    );
};
